const { getElement, getElements } = window.BAO.Utils

export class DrawerQuickBuy extends customElements.get('site-drawer') {
  constructor () {
    super()
    // Used for section rendering API
    this.sectionId = 'quick-buy'

    if (this.getAttribute('data-drawer-quick-buy-el') == 'bundle') {
      this.sectionId = 'quick-buy-bundles'
    }
  }

  static get observedAttributes () {
    return ['reinitialise']
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'reinitialise' && newValue === 'true') {
      this.addClickListeners()
      this.unhideEls()
    }
  }

  connectedCallback () {
    super.connectedCallback()

    this.unhideEls()
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.addClickListeners.bind(this),
    )

    this.handleTrigger = this.handleTrigger.bind(this)
    this.addClickListeners()
  }

  unhideEls () {
    this.triggers.forEach(trigger => trigger.removeAttribute('hidden'))
  }

  addClickListeners () {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const triggers = getElements('[data-drawer-quick-buy-external-el="trigger"]')
          if (triggers.length > 0) {
            this.triggers = getElements('[data-drawer-quick-buy-external-el="trigger"]')
            this.body = getElement('[data-drawer-quick-buy-el="body"]', { context: this })

            this.triggers.forEach(trigger => {
              this.listeners.add(trigger, 'click', (event) => this.handleTrigger(event))
            })

            observer.disconnect()
            break
          }
        }
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    this.triggers = getElements('[data-drawer-quick-buy-external-el="trigger"]')
    this.body = getElement('[data-drawer-quick-buy-el="body"]', { context: this })

    this.triggers.forEach(trigger => {
      this.listeners.add(trigger, 'click', (event) => this.handleTrigger(event))
    })

    document.addEventListener(window.BAO.EVENTS.PAGINATION.RENDER, () => {
      this.triggers = getElements('[data-drawer-quick-buy-external-el="trigger"]')

      this.handleTrigger = this.handleTrigger.bind(this)

      this.triggers.forEach(trigger => {
        this.listeners.remove(trigger, 'click', (event) => this.handleTrigger(event))
      })

      this.triggers.forEach(trigger => {
        this.listeners.add(trigger, 'click', (event) => this.handleTrigger(event))
      })

      this.triggers.forEach(trigger => trigger.removeAttribute('hidden'))
    })
  }

  handleTrigger (event) {
    const triggerElement = event.target

    const productUrl = triggerElement?.dataset.productUrl

    if (!productUrl) return

    this.renderDrawerContent(productUrl)
  }

  async renderDrawerContent (productUrl) {
    const html = await this.sectionRenderer.fetchSingle(this.sectionId, productUrl)

    const innerHtml = this.sectionRenderer.getInnerHtml(html)
    if (!html || !innerHtml) return

    this.updateBodyContent(innerHtml)
    this.openDrawer()
  }

  openDrawer () {
    getElement('site-drawers')?.open(this.getAttribute('key'))
  }

  closeDrawer () {
    getElement('site-drawers')?.closeDrawer(this.getAttribute('key'))
  }

  updateBodyContent (content) {
    this.body.innerHTML = ''
    this.body.insertAdjacentHTML('beforeend', content)
  }

  /**
   * @returns {sectionRenderer} The BAO sectionRenderer class
   */
  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }
}

customElements.define('drawer-quick-buy', DrawerQuickBuy)
